<template>
<div>
	<h3>Project Labour Report</h3>
	<table-list 
		record-name="Classification"
		:fields="fields"
		:records="classificationsFromBid"
		:hide-record-count="true"
		:sortable="true">
	</table-list>

	<div v-if="$store.project && $store.project.detailed_timelogs == 1">
		<h3>Detailed Logs</h3>

		<div v-if="$store.project.detailed_timelogs_depth == 0">

			<table-list
				v-for="cat in nestedBidWithDetailedClaims"
				:key="cat.id"
				record-name="Classification"
				:fields="fields"
				:records="classifyComponentClaims(cat.TimeLogDetailedClaim,cat)"
				:sortable="true">

				<h4>{{ cat.name }}</h4>

			</table-list>
		</div>

		<accordion v-else-if="$store.project.detailed_timelogs_depth == 1"
			v-for="(compCat,index) in nestedBidWithDetailedClaims"
			:heading="compCat.name"
			:key="'accordion_' + index">

			<table-list v-for="subComp in compCat.JobBidComponent"
				:key="subComp.id"
				record-name="Classification"
				:fields="fields"
				:records="classifyComponentClaims(subComp.TimeLogDetailedClaim,subComp)"
				:sortable="true">

				<h4>{{ subComp.item_number }}: {{ subComp.name }}</h4>

			</table-list>

		</accordion>
	</div>
</div>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Accordion from "@/components/Accordion"

import JobMixins from "@/mixins/JobMixins.js"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "LabourReport",
	mixins: [JobMixins,ProjectBidMixins],
	components: {
		TableList,
		Accordion
	},
	mixins: [ProjectBidMixins],
	data() {
		return {
			classificationsInEstimate: [],
			timeLogs: [],
			timeLogFetchProgress: 0,
			timeLogFetchCompleted: false,
			dataFetched: false,
			bid: null
		}
	},
	watch: {
		'$store.project'() {
			//if (!this.dataFetched && this.reportNeedsFetching())
				this.fetchData()
		}
	},
	computed: {
		fields() {
			let fields = [
				{label: 'Classification',key:'lineLabel'},
				//{label: "Hours Type",key:'hourType'},
				{label: 'Estimated Hours',key:'estimatedHrs',align:"right"},
				{label: 'Hrs to Date',key:'actualHrs',align:"right"},
				{label: 'Estimated Cost',key:'costAllowed',align:"right"},
				{label: 'Actual Cost',key:'actualCost',align:"right"},
				{label: '% Complete',key:'percentComplete',align:"right"},
				{label: 'Over/Under',key:'overUnder',align:"right"},
			]

			return fields
		},
		classificationsFromBid() {
			let classifications = [], vm = this

			let hourTypeLabelMap = {
				regular_hours: "Reg",
				overtime_hours_15x: "1.5x OT",
				overtime_hours_2x: "2x OT",
				overtime_hours_25x: "2.5x OT"
			}

			let hourTypeValueMap = {
				regular_hours: 1,
				overtime_hours_15x: 1.5,
				overtime_hours_2x: 2,
				overtime_hours_25x: 2.5
			}

			let hourTypeKeyMap = {
				"1" : "regular_hours",
				"1.5" : "overtime_hours_15x",
				"2" : "overtime_hours_2x",
				"2.5" : "overtime_hours_25x"
			}

			vm.timeLogs.forEach(log => {
				let classification = false
				try {
					classification = JSON.parse(log.classification_json)
				}
				catch (e) {}

				if (classification) {

					let matchIndex = -1

					//check if it exists already
					if ("id" in classification)
						matchIndex = classifications.findIndex(clAdded => clAdded.classification_id == classification.id)
					else
						matchIndex = classifications.findIndex(clAdded => clAdded.classificationTitle == "Unclassified")

					if (matchIndex >= 0) {
						Object.keys(hourTypeLabelMap).forEach(type => {
							if (type in log && +log[type] > 0) {
								classifications[matchIndex].hourTypes[type].totalActual += +log[type]

								classifications[matchIndex].actualHoursTotalRaw += +log[type]
							}
							
						})

						classifications[matchIndex].actualCostRaw += +log.calculated_cost
						classifications[matchIndex].actualCost = classifications[matchIndex].actualCostRaw.toCurrency()
					}
					else {
						let hourTypeValues = {}, totalClassificationHours = 0
						Object.keys(hourTypeLabelMap).forEach(type => {
							if (type in log && +log[type] > 0) {
								hourTypeValues[type] = {
									totalActual: +log[type],
									totalEstimated: 0,
									costAllowed: 0
								}

								totalClassificationHours += +log[type]
							}
							else
								hourTypeValues[type] = {
									totalActual: 0,
									totalEstimated: 0,
									costAllowed: 0
								}
						})

						let classificationTitle = "Unclassified"
						if ("title" in classification)
							classificationTitle = classification.title

						classifications.push({
							classificationTitle,
							classification_id: classification.id,
							hourTypes: hourTypeValues,
							actualHoursTotalRaw: totalClassificationHours,
							actualCostRaw: +log.calculated_cost
						})
					}
				}
				else {
					//this log does belongs to an unclassified employee

				}
			})

			let flattenedRecords = this.flattenRecordsFromNested()

			this.flattenRecordsFromNested().filter(element => element.type == "EmployeeClassification").forEach(cl => {

				let parsedFields = JSON.parse(cl.field_values_json)

				if (!"hours_type" in parsedFields || !parsedFields.hours_type)
					parsedFields.hours_type = 1

				let costAllowed = parsedFields.hrs * +parsedFields.rate

				let matchIndex = classifications.findIndex(clAdded => clAdded.classification_id == parsedFields.classification_id)

				if (matchIndex >= 0) {
					let costAllowedRaw = +parsedFields.hrs * +parsedFields.rate

					if (hourTypeKeyMap[parsedFields.hours_type] in classifications[matchIndex].hourTypes) {
						classifications[matchIndex].hourTypes[hourTypeKeyMap[parsedFields.hours_type]].totalEstimated += +parsedFields.hrs
						classifications[matchIndex].hourTypes[hourTypeKeyMap[parsedFields.hours_type]].costAllowed += +costAllowed
					}
					else {
						classifications[matchIndex].hourTypes[hourTypeKeyMap[parsedFields.hours_type]] = {
							totalActual: 0,
							totalEstimated: +parsedFields.hrs,
							costAllowed
						}
					}
				}
				else {		
					let hourTypes = {}

					hourTypes[hourTypeKeyMap[parsedFields.hours_type]] = {
						totalActual: 0,
						totalEstimated: +parsedFields.hrs,
						costAllowed
					}

					let classificationTitle = ""
					if ("classificationTitle" in parsedFields)
						classificationTitle = parsedFields.classificationTitle
					else if ("title" in parsedFields)
						classificationTitle = parsedFields.title

					classifications.push({
						classificationTitle,
						classification_id: parsedFields.classification_id,
						hourTypes,
						actualHoursTotalRaw: 0,
						actualCostRaw: 0
					})
				}
			})

			let expanded = []
			classifications.forEach(cl => {

				let totalCostAllowedRaw = Object.keys(cl.hourTypes).reduce((acc,key) => acc + cl.hourTypes[key].costAllowed,0)

				let percentCompleteRaw = cl.actualCostRaw / totalCostAllowedRaw * 100

				let percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)
				if (totalCostAllowedRaw == 0)
					percentComplete = "<small class='text-danger'>No Budget</small>"

				let overUnder = totalCostAllowedRaw - cl.actualCostRaw

				let overUnderClass = ""
				if (overUnder > 0)
					overUnderClass = "text-success"
				else if (overUnder < 0)
					overUnderClass = "text-danger"

				overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

				expanded.push({
					lineLabel: "<strong>" + cl.classificationTitle + "</strong>",
					estimatedHrs: "<strong>" + Object.keys(cl.hourTypes).reduce((acc,key) => acc + cl.hourTypes[key].totalEstimated,0).toFixed(2) + "</strong>",
					actualHrs: "<strong>" + cl.actualHoursTotalRaw.toFixed(2) + "</strong>",
					costAllowed: "<strong>" + totalCostAllowedRaw.toCurrency() + "</strong>",
					actualCost: "<strong>" + cl.actualCostRaw.toCurrency() + "</strong>",
					percentComplete,
					overUnder
				})

				Object.keys(cl.hourTypes).forEach(key => {

					if (cl.hourTypes[key].totalEstimated > 0 || cl.hourTypes[key].totalActual > 0 || cl.hourTypes[key].costAllowedRaw > 0) {
						expanded.push({
							lineLabel: "&nbsp; &nbsp; " + hourTypeLabelMap[key],
							estimatedHrs: cl.hourTypes[key].totalEstimated.toFixed(2),
							actualHrs: cl.hourTypes[key].totalActual.toFixed(2),
							costAllowed: cl.hourTypes[key].costAllowed.toCurrency(),
							actualCost: "",
							percentComplete: "",
							overUnder: ""
						})
					}
				})
			})

			return expanded
		},
		mutatedClassifications() {
			let vm = this

			let totals = {
				estimatedHrs: 0,
				estimatedCost: 0,
				reg: 0,
				OT15: 0,
				OT2: 0,
				OT25: 0,
				actualCost: 0,
				overUnder: 0,
				percentComplete: 0
			}

			let rows = this.classificationsInEstimate.map(cl => {

				cl.actualReg = "0.00"
				cl.actualOT15 = "0.00"
				cl.actualOT2 = "0.00"
				cl.actualOT25 = "0.00"

				if ("hrsToDate" in cl) {

					if ("reg" in cl.hrsToDate && cl.hrsToDate.reg > 0)
						cl.actualReg = cl.hrsToDate.reg.toCurrency()

					if ("OT15" in cl.hrsToDate && cl.hrsToDate.OT15 > 0)
						cl.actualOT15 = cl.hrsToDate.OT15.toCurrency()

					if ("OT2" in cl.hrsToDate && cl.hrsToDate.OT2 > 0)
						cl.actualOT2 = cl.hrsToDate.OT2.toCurrency()

					if ("OT25" in cl.hrsToDate && cl.hrsToDate.OT25 > 0)
						cl.actualOT25 = cl.hrsToDate.OT25.toCurrency()
				}
				else 
					cl.hrsToDate = {}

				let overUnder = cl.costAllowedRaw - cl.actualCostRaw

				let overUnderClass = ""
				if (overUnder > 0)
					overUnderClass = "text-success"
				else if (overUnder < 0)
					overUnderClass = "text-danger"

				cl.overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

				cl.costAllowed = cl.costAllowedRaw.toCurrency()
				cl.actualCost = "$"+cl.actualCost

				let percentCompleteRaw = 0
				if (cl.actualCostRaw != 0 && cl.costAllowedRaw != 0)
						percentCompleteRaw = cl.actualCostRaw / cl.costAllowedRaw * 100

				cl.percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)

				if (cl.costAllowedRaw == 0)
					cl.percentComplete = "<small class='text-danger'>No Budget</small>"

				totals.estimatedHrs += +cl.estimatedHrs
				totals.estimatedCost += cl.costAllowedRaw
				totals.reg += "reg" in cl.hrsToDate ? cl.hrsToDate.reg : 0
				totals.OT15 += "OT15" in cl.hrsToDate ? cl.hrsToDate.OT15 : 0
				totals.OT2 += "OT2" in cl.hrsToDate ? cl.hrsToDate.OT2 : 0
				totals.OT25 += "OT25" in cl.hrsToDate ? cl.hrsToDate.OT25 : 0
				totals.actualCost += cl.actualCostRaw
				totals.overUnder += overUnder

				let estimatedHrsRaw = +cl.estimatedHrs
				cl.estimatedHrs = estimatedHrsRaw.toFixed(2)

				return cl
			})

			let percentComplete = 0;
			if (totals.actualCost > 0 && totals.estimatedCost > 0)	
				percentComplete = totals.actualCost / totals.estimatedCost * 100

			totals.percentComplete = percentComplete

			let overUnderClass = ""
			if (totals.overUnder > 0)
				overUnderClass = "text-success"
			else if (totals.overUnder < 0)
				overUnderClass = "text-danger"

			let overUnderRow = "<span class='"+overUnderClass+"'>$"+totals.overUnder.toCurrency()+"</span>"

			//add totals row
			rows.push({
				tfoot: true,
				rowClasses: "font-weight-bold",
				title: "Totals",
				estimatedHrs: totals.estimatedHrs.toFixed(2),
				costAllowed: totals.estimatedCost.toCurrency(),
				actualReg: totals.reg.toFixed(2),
				actualOT15: totals.OT15.toFixed(2),
				actualOT2: totals.OT2.toFixed(2),
				actualOT25: totals.OT25.toFixed(2),
				actualCost: totals.actualCost.toCurrency(),
				percentComplete: totals.percentComplete.toFixed(1)+"%",
				overUnder: overUnderRow
			})

			return rows

		},
		nestedBidWithDetailedClaims() {
			let vm = this

			let mutated = []

			this.bidComponentsNested.forEach(cat => {
				let mutatedCat = vm.cloneObj(cat)

				mutatedCat.timeLogDetailedClaims = []
				vm.timeLogs.forEach(log => {

					if ("TimeLogDetailedClaim" in log && log.TimeLogDetailedClaim) {
						log.TimeLogDetailedClaim
							.filter(claim => claim.job_bid_component_id == cat.id)
							.forEach(claim => {
								if (!("timeLogDetailedClaims" in mutated) || !mutated.timeLogDetailedClaims)
									mutated.timeLogDetailedClaims = []

								mutated.timeLogDetailedClaims.push(claim)
							})
					}
					return true
				})

				mutated.push(mutatedCat)
			})

			return mutated
		}
	},
	methods: {
		/*
		reportNeedsFetching() {
			return true //to be removed later

			if (!("labourEstimateJobSlug" in localStorage) || localStorage.labourEstimateJobSlug != this.$route.params.id || this.moment().diff(this.moment(localStorage.labourEstimateCachedAt),"hours") > 24)
				return true

			else
				return false
		},
		
		mergeEstimate() {
			let vm = this

			if ("JobEstimate" in this.$store.project) {

				let labourEstimate = []
				try {
					labourEstimate = JSON.parse(this.$store.project.JobEstimate[0].labour_json)
				}
				catch (e) {}

				let notFoundList = []

				this.classificationsInEstimate = this.classificationsInEstimate.map(cl => {
					//look for matching estimate item

					let item = labourEstimate.find(estimateClassification => estimateClassification.id == cl.id)

					cl.estimatedHrs = "0.00"
					if (item) {

						cl.estimatedHrs = item.estimatedHrs
						cl.costAllowedRaw = item.costAllowedRaw
						cl.costAllowed = cl.costAllowedRaw.toCurrency()
						
						let percentCompleteRaw = 0
						if (cl.actualCostRaw != 0 && cl.costAllowedRaw != 0)
							percentCompleteRaw = cl.actualCostRaw / cl.costAllowedRaw * 100

						cl.percentCompleteRaw = percentCompleteRaw
					}

					return cl
				})

				//find the estimate line items that DON'T have time logs, and add them to the report
				labourEstimate.forEach(line => {
					let found = vm.classificationsInEstimate.find(cl => cl.id == line.id)

					if (!found) {
						line.actualCost = "0.00"
						line.actualCostRaw = 0
						line.percentComplete = "0.0%"
						line.overUnder = "<span class='text-success'>$"+line.costAllowedRaw.toCurrency()+"</span>"

						vm.classificationsInEstimate.push(line)
					}				
				})
			}
		},
		classifyTimeLogs() {
			let vm = this

			if (this.$store.project.TimeLog) {

				//reset hrs to date
				this.classificationsInEstimate = this.classificationsInEstimate.map(cl => {
					cl.hrsToDate = {}

					return cl
				})

				this.$store.project.TimeLog.filter(log => log.submitted_by > 0).forEach(log => {

					let logClassification = false, classification
					try {
						logClassification = JSON.parse(log.classification_json)
					}
					catch (e) {}
					
					if (logClassification) 
						classification = vm.classificationsInEstimate.find(clAdded => logClassification.id == clAdded.id)
					
					if (!classification) {
						//classification from log does not exist, so we have to go the user's live one
						classification = vm.classificationsInEstimate.find(clAdded => log.User.EmployeeClassification.length > 0 && log.User.EmployeeClassification[0].classification_id == clAdded.id)
					}

					if (!classification) {

						//not added yet, we need to add it automatically
						classification = log.User.EmployeeClassification.length > 0 ? log.User.EmployeeClassification[0] : false

						if (classification) {

							let hrsToDate = {}
							let hrsRemaining = 0
							let actualCostRaw = 0

							if (parseFloat(log.regular_hours) > 0) {
								hrsToDate.reg = parseFloat(log.regular_hours)
								hrsRemaining -= hrsToDate.reg
							}

							if (parseFloat(log.overtime_hours_15x) > 0) {
								hrsToDate.OT15 = parseFloat(log.overtime_hours_15x)
								hrsRemaining -= hrsToDate.OT15
							}

							if (parseFloat(log.overtime_hours_2x) > 0) {
								hrsToDate.OT2 = parseFloat(log.overtime_hours_2x)
								hrsRemaining -= hrsToDate.OT2
							}

							if (parseFloat(log.overtime_hours_25x) > 0) {
								hrsToDate.OT25 = parseFloat(log.overtime_hours_25x)
								hrsRemaining -= hrsToDate.OT25
							}

							actualCostRaw = +log.calculated_cost

							let costAllowedRaw = 0
							let costAllowed = costAllowedRaw.toCurrency()

							let actualCost = actualCostRaw.toCurrency()

							let percentCompleteRaw = 0
							if (actualCostRaw != 0 && costAllowedRaw != 0)
								percentCompleteRaw = actualCostRaw / costAllowedRaw * 100

							let obj = {
								id: classification.classification_id,
								title: classification.title,
								union_id: classification.union_id,
								estimatedHrs: "0.00",
								hrsToDate,
								hrsRemaining,
								costAllowed,
								costAllowedRaw,
								actualCost,
								actualCostRaw,
								percentComplete: percentCompleteRaw.toFixed(1)+"%",
								percentCompleteRaw
							}

							vm.classificationsInEstimate.push(obj)
						}
					}
					else {
						//add to the current totals
						if (parseFloat(log.regular_hours) > 0) {
							if (!("reg" in classification.hrsToDate))
								classification.hrsToDate.reg = parseFloat(log.regular_hours)
							else
								classification.hrsToDate.reg += parseFloat(log.regular_hours)
						}

						if (parseFloat(log.overtime_hours_15x) > 0) {
							if (!("OT15" in classification.hrsToDate))
								classification.hrsToDate.OT15 = parseFloat(log.overtime_hours_15x)
							else
								classification.hrsToDate.OT15 += parseFloat(log.overtime_hours_15x)
						}

						if (parseFloat(log.overtime_hours_2x) > 0) {
							if (!("OT2" in classification.hrsToDate))
								classification.hrsToDate.OT2 = parseFloat(log.overtime_hours_2x)
							else
								classification.hrsToDate.OT2 += parseFloat(log.overtime_hours_2x)
						}

						if (parseFloat(log.overtime_hours_25x) > 0) {
							if (!("OT25" in classification.hrsToDate))
								classification.hrsToDate.OT25 = parseFloat(log.overtime_hours_25x)
							else
								classification.hrsToDate.OT25 += parseFloat(log.overtime_hours_25x)
						}

						classification.actualCostRaw += +log.calculated_cost
						classification.actualCost = classification.actualCostRaw.toCurrency()

					}
				})
			}
		},
		*/
		classifyComponentClaims(claims,component) {
			let classifications = [], vm = this

			let elements = this.getTotalElementsOnComponent(component, "EmployeeClassification")

			let jobCAs = {}
			try {
				jobCAs = JSON.parse(this.$store.project.collective_agreements_json)
			}
			catch (ex) {}

			if (claims) {
				claims.forEach(claim => {
					let log = vm.timeLogs.find(log => log.id == claim.timelog_id)

					let logClassification = {}
					try {
						logClassification = JSON.parse(log.classification_json)
					}
					catch (e) {}

					if (logClassification) {

						let collectiveAgreement = vm.$store.collectiveAgreements.find(ca => ca.id == jobCAs[logClassification.union_id])

						let payScales = []
						try {
							payScales = JSON.parse(collectiveAgreement.pay_scales)
						}
						catch (e) {}

						let classificationPayscale = payScales.find(ps => ps.classification_id == logClassification.id)

						let foundIndex = -1

						if ("id" in logClassification)
							foundIndex = classifications.findIndex(cl => cl.id == logClassification.id)
						else
							foundIndex = classifications.findIndex(cl => cl.title == "Unclassified")

						if (foundIndex == -1) {

							let title = "Unclassified"
							if ("title" in logClassification)
								title = logClassification.title

							let clId = 0
							if ("id" in logClassification)
								clId = logClassification.id

							let clToPush = {
								lineLabel: title,
								title,
								id: clId,
								regRaw: +claim.regular_hours,
								OT15Raw: +claim.overtime_hours_15x,
								OT2Raw: +claim.overtime_hours_2x,
								OT25Raw: +claim.overtime_hours_25x
							}

							let filteredElements = elements
								.filter(el => el.parsedFields.classification_id == logClassification.id)

							let estimatedHrs = filteredElements.reduce((acc,el) => acc + el.qty,0)

							clToPush.estimatedHrs = estimatedHrs.toFixed(2)

							let costAllowed = filteredElements.reduce((acc,el) => acc + (+el.qty * +el.rate),0)

							clToPush.costAllowed = costAllowed.toCurrency()					

							let actualCost = 0

							/*
							if (clToPush.id > 0) {

								if (classificationPayscale) {
									clToPush.payScale = classificationPayscale

									let regCostHr = "cost_hr" in classificationPayscale ? classificationPayscale.cost_hr : logClassification.default_cost_hr
									let ot15CostHr = "ot15_cost_hr" in classificationPayscale ? classificationPayscale.ot15_cost_hr : logClassification.ot15_cost_hr
									let ot2CostHr = "ot2_cost_hr" in classificationPayscale ? classificationPayscale.ot2_cost_hr : logClassification.ot2_cost_hr
									let ot25CostHr = "ot25_cost_hr" in classificationPayscale ? classificationPayscale.ot25_cost_hr : logClassification.ot25_cost_hr

									actualCost = 	(clToPush.regRaw * +regCostHr) + 
														(clToPush.OT15Raw * +ot15CostHr) + 
														(clToPush.OT2Raw * +ot2CostHr) + 
														(clToPush.OT25Raw * +ot25CostHr)
								}


								clToPush.actualCostRaw = actualCost
							}
							else {
								clToPush.actualCostRaw = actualCost
							}
							*/

							let costFields = ["calculated_cost_regular_hours","calculated_cost_overtime_hours_15x","calculated_cost_overtime_hours_2x","calculated_cost_overtime_hours_25x"]

							clToPush.actualCostRaw = 0
							costFields.forEach(key => {
								let parsedValue = +claim[key]

								if (!isNaN(parsedValue))
									clToPush.actualCostRaw += parsedValue
							})

							let percentCompleteRaw = 0
							if (clToPush.actualCostRaw != 0 && +clToPush.costAllowed != 0)
								percentCompleteRaw = clToPush.actualCostRaw / +clToPush.costAllowed * 100

							clToPush.percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)

							let overUnder = +clToPush.costAllowed - clToPush.actualCostRaw

							let overUnderClass = ""
							if (overUnder > 0)
								overUnderClass = "text-success"
							else if (overUnder < 0)
								overUnderClass = "text-danger"

							clToPush.overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

							clToPush.actualCost = clToPush.actualCostRaw.toCurrency()

							clToPush.actualHrsRaw = clToPush.regRaw + clToPush.OT15Raw + clToPush.OT2Raw + clToPush.OT25Raw 

							clToPush.actualReg = clToPush.regRaw.toFixed(2)
							clToPush.actualOT15 = clToPush.OT15Raw.toFixed(2)
							clToPush.actualOT2 = clToPush.OT2Raw.toFixed(2)
							clToPush.actualOT25 = clToPush.OT25Raw.toFixed(2)

							clToPush.actualHrs = clToPush.actualHrsRaw.toFixed(2)

							classifications.push(clToPush)
						}
						else {
							
							classifications[foundIndex].regRaw += +claim.regular_hours
							classifications[foundIndex].OT15Raw += +claim.overtime_hours_15x
							classifications[foundIndex].OT2Raw += +claim.overtime_hours_2x
							classifications[foundIndex].OT25Raw += +claim.overtime_hours_25x

							/*
							let regCostHr = classificationPayscale && "cost_hr" in classificationPayscale ? classificationPayscale.cost_hr : logClassification.default_cost_hr
							let ot15CostHr = classificationPayscale && "ot15_cost_hr" in classificationPayscale ? classificationPayscale.ot15_cost_hr : logClassification.ot15_cost_hr
							let ot2CostHr = classificationPayscale && "ot2_cost_hr" in classificationPayscale ? classificationPayscale.ot2_cost_hr : logClassification.ot2_cost_hr
							let ot25CostHr = classificationPayscale && "ot25_cost_hr" in classificationPayscale ? classificationPayscale.ot25_cost_hr : logClassification.ot25_cost_hr

							let actualCost = 	(classifications[foundIndex].regRaw * +regCostHr) + 
												(classifications[foundIndex].OT15Raw * +ot15CostHr) + 
												(classifications[foundIndex].OT2Raw * +ot2CostHr) + 
												(classifications[foundIndex].OT25Raw * +ot25CostHr)


							classifications[foundIndex].actualCostRaw += actualCost
							*/

							let costFields = ["calculated_cost_regular_hours","calculated_cost_overtime_hours_15x","calculated_cost_overtime_hours_2x","calculated_cost_overtime_hours_25x"]

							costFields.forEach(key => {
								let parsedValue = +claim[key]

								if (!isNaN(parsedValue)) {

									classifications[foundIndex].actualCostRaw += parsedValue
								}
							})

							let percentCompleteRaw = 0
							if (classifications[foundIndex].actualCostRaw != 0 && +classifications[foundIndex].costAllowed != 0)
								percentCompleteRaw = classifications[foundIndex].actualCostRaw / +classifications[foundIndex].costAllowed * 100

							classifications[foundIndex].percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)

							let overUnder = +classifications[foundIndex].costAllowed - classifications[foundIndex].actualCostRaw

							let overUnderClass = ""
							if (overUnder > 0)
								overUnderClass = "text-success"
							else if (overUnder < 0)
								overUnderClass = "text-danger"

							classifications[foundIndex].overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

							classifications[foundIndex].actualCost = classifications[foundIndex].actualCostRaw.toCurrency()
							classifications[foundIndex].actualHrs += classifications[foundIndex].regRaw + classifications[foundIndex].OT15Raw + classifications[foundIndex].OT2Raw + classifications[foundIndex].OT25Raw

							classifications[foundIndex].actualReg = classifications[foundIndex].regRaw
							classifications[foundIndex].actualOT15 = classifications[foundIndex].OT15Raw
							classifications[foundIndex].actualOT2 = classifications[foundIndex].OT2Raw
							classifications[foundIndex].actualOT25 = classifications[foundIndex].OT25Raw

							classifications[foundIndex].actualHrs = classifications[foundIndex].actualHrsRaw.toFixed(2)
						}
					}
				})
			}

			return classifications
		},
		fetchAllTimeLogPages(spinner) {
			let vm = this

			let page = 1

			this.timeLogFetchCompleted = false
			this.timeLogReportGeneratingInProgress = true

			if (spinner)
				this.spinner(true,this.timeLogFetchProgress+"%")

			return new Promise((resolve,reject) => {

				vm.fetchTimeLogPage(page).then(response => {

					let numPages = response.meta.num_pages

					let cntResolves = 1;

					vm.timeLogs = response.data

					if (numPages > 1) {

						for (var p = 2; p <= numPages; p++) {
							vm.fetchTimeLogPage(p).then(response => {

								cntResolves++

								vm.timeLogFetchProgress = Math.floor(cntResolves / numPages * 100)

								if (spinner)
									vm.spinner(true,vm.timeLogFetchProgress+"%")

								if (response)
									vm.timeLogs = vm.timeLogs.concat(response.data)

								if (vm.timeLogFetchProgress >= 100) {
									//COMPLETE

									if (spinner)
										vm.spinner(false)

									vm.timeLogFetchCompleted = true

									vm.$store.project.TimeLog = vm.timeLogs

									resolve(vm.$store.project.TimeLog)
								}
							})
						}
					}
					else {

						if (spinner)
							vm.spinner(false)

						vm.timeLogFetchCompleted = true

						vm.$store.project.TimeLog = vm.timeLogs

						vm.timeLogFetchProgress = 100
						resolve(vm.$store.project.TimeLog)
					}
				})
			})
			
		},
		fetchTimeLogPage(page) {
			let vm = this

			let include = [
				{
					model: "User",
					include: [{model:"EmployeeClassification",fields:["id","title","classification_id","default_cost_hr","ot15_cost_hr","ot2_cost_hr","ot25_cost_hr","union_id"]}],
					fields: ["id","slug","first_name","last_name"]
				}
			]

			if (this.$store.project.detailed_timelogs == 1) 
				include.push("TimeLogDetailedClaim")

			let params = {
				filters: [
					["job_id",this.$store.project.id]
				],
				include,
				fields: ["id","slug","regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x","job_id","service_id","collective_agreement_id","classification_json","calculated_cost","submitted_by"],
				page: page
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("TimeLog/get",params).then(response => {

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [], bidPromiseIndex = false, reportBeingFetched = false
			if ("slug" in this.$store.project && this.$store.project.slug == this.$route.params.id) {

				if (!this.dataFetched /* && this.reportNeedsFetching()*/) {
					reportBeingFetched = true

					promises = [
						this.fetchAllTimeLogPages(true),
						//this.fetchEstimate(this.$route.params.id),
						this.getJSON("TimeLogSetting/get"),
						this.getJSON("CollectiveAgreement/get"),
						this.fetchActiveBid({
							projectId: vm.$store.project.id
						})
					]
				}

				if (this.$store.project.detailed_timelogs == 1) {
					promises.push(this.getJSON("EmployeeClassification/get"))
				}

				Promise.all(promises).then(responses => {

					if (reportBeingFetched) {
						vm.$store.timeLogSettings = responses[1].data[0]

						vm.$store.collectiveAgreements = responses[2].data

						vm.dataFetched = true

						//vm.classifyTimeLogs()

						/*
						vm.mergeEstimate()
					
						localStorage.labourEstimate = JSON.stringify(vm.classificationsInEstimate)
						localStorage.labourEstimateCachedAt = vm.moment().format("YYYY-MM-DD HH:mm")
						localStorage.labourEstimateJobSlug = vm.$route.params.id
						*/

						vm.bid = responses[3]

						vm.fetchAllComponents(vm.bid.id,[
							{model: 'JobBidComponentObject',filters:[["type","EmployeeClassification"]]},
							"TimeLogDetailedClaim"
						])

						//vm.detailedTimelogClaims = responses[bidPromiseIndex + 1].data

						if (promises.length == 5)
							vm.$store.employeeClassifications = responses[4].data

					}
					
				})
			}
		}
	},
	created() {
		this.fetchData()
	}
}
</script>